const _ = require('lodash');

exports.createFullIndexUrl = (prefix, relativePath, endingSlash = true) => {
  if (prefix === 'blog') {
    return `/blog/${relativePath}${endingSlash ? '/' : ''}`;
  }

  if (prefix === 'tutorial') {
    return `/community/tutorials/${relativePath}${endingSlash ? '/' : ''}`;
  }

  if (prefix === 'media') {
    return `/press/media/${relativePath}${endingSlash ? '/' : ''}`;
  }
};

exports.createFullSingleUrl = (prefix, relativePath, endingSlash = true) => {
  let pathPrefix = '';

  if (prefix === 'tutorial') {
    pathPrefix = '/community/tutorials';
  } else if (prefix === 'blog') {
    pathPrefix = `/${prefix}`;
  } else if (prefix === 'chaos-monkey') {
    pathPrefix = `/${prefix}`;
  } else if (prefix === 'chaos-monkey-alternatives') {
    pathPrefix = `/chaos-monkey/${prefix}`;
  } else if (prefix === 'docs') {
    pathPrefix = `/${prefix}`;
  } else if (prefix === 'case-studies') {
    pathPrefix = '/customers';
  } else if (prefix === 'webinars') {
    pathPrefix = `/${prefix}`;
  } else if (prefix === 'chaos-engineering') {
    pathPrefix = `/${prefix}`;
  }

  return `${pathPrefix}/${relativePath}${endingSlash ? '/' : ''}`;
};

exports.getArticleType = node => {
  if (node.fileAbsolutePath.includes('/src/posts/')) {
    return 'blog';
  }

  if (node.fileAbsolutePath.includes('/src/tutorials/')) {
    return 'tutorial';
  }

  if (node.fileAbsolutePath.includes('/src/static-pages/')) {
    return 'static-pages';
  }

  if (node.fileAbsolutePath.includes('/src/webinars/')) {
    return 'webinars';
  }

  if (node.fileAbsolutePath.includes('/src/case-studies/')) {
    return 'case-studies';
  }

  if (node.fileAbsolutePath.includes('/src/chaos-engineering/')) {
    return 'chaos-engineering';
  }

  if (node.fileAbsolutePath.includes('/src/media/')) {
    return 'media';
  }

  if (
    node.fileAbsolutePath.includes('/src/whitepaper-landing-pages/') ||
    node.fileAbsolutePath.includes('/src/sign-up-landing-pages/') ||
    node.fileAbsolutePath.includes('/src/demo-column-variation-landing-pages')
  ) {
    return 'landing-page';
  }

  // Make sure we do this one first so more descriptive matches can go first
  if (
    node.fileAbsolutePath.includes(
      '/src/chaos-monkey/chaos-monkey-alternatives/'
    )
  ) {
    return 'chaos-monkey-alternatives';
  }

  if (node.fileAbsolutePath.includes('/src/chaos-monkey/')) {
    return 'chaos-monkey';
  }

  if (node.fileAbsolutePath.includes('/src/docs/articles/')) {
    return 'docs';
  }
};

// This is used within our Resources section
exports.getArticleLabel = type => {
  switch (type) {
    case 'blog':
      return 'Blog Posts';

    case 'tutorial':
      return 'Tutorials';

    case 'webinars':
      return 'Webinars';

    case 'case-studies':
      return 'Case Studies';

    case 'chaos-engineering':
    case 'chaos-monkey':
    case 'chaos-monkey-alternatives':
      return 'Microsites';

    case 'landing-page':
      return 'Whitepapers';

    case 'docs':
      return 'Docs';

    default:
      return 'Page';
  }
};

exports.createCategoryMap = edges => {
  const categories = {};

  edges.forEach(({ node }) => {
    if (node.frontmatter.categories) {
      node.frontmatter.categories.forEach(category => {
        if (!categories[category]) {
          categories[category] = {
            name: category,
            slug: `category/${_.kebabCase(_.toLower(category))}`,
            nodes: [],
          };
        }

        categories[category].nodes.push(node);
      });
    }
  });

  return categories;
};

exports.createAuthorMap = edges => {
  const authors = {};

  edges.forEach(({ node }) => {
    const { author } = node.frontmatter;

    if (author) {
      if (!authors[author]) {
        authors[author] = {
          name: author,
          slug: `author/${_.kebabCase(_.toLower(author))}`,
          nodes: [],
        };
      }

      authors[author].nodes.push(node);
    }
  });

  return authors;
};

// Used for `make-relative` gastby+remark plugin
// Purposely not including Netlify-only redirects since `gatsby-catch-links` will attempt to use React's internal router to push to these pages; even though they don't exist (as-is) on the site.
exports.domainRegex = /http[s]*:\/\/[www.]*gremlin\.com(?!\/slack|\/chaos-conf-2019|\/kubecon|\/free|\/events)[/]?/;

exports.defaultFeaturedImage =
  'https://res.cloudinary.com/gremlin/image/upload/c_limit,q_80,w_2000/default-featured-image.png';
